import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { adminPrefix } from 'configs/routePrefix';
import StatusModal from "../StatusModal"
import FeedbackModal from "../FeedbackModal"
import AssignSalesRepModal from "../AssignSalesRep"
import LeadService from 'services/Admin/LeadService';
import { useSelector, useDispatch } from "react-redux";

const CardItem = ({ history, item, setShouldGetData,setIdsSelected, idsSelected, setSelectAll }) => {
    const AuthData = useSelector(state => state.Auth);
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const leadService = new LeadService()
    const [modalStatus, setModalStatus] = useState(false)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [salesRepModal, setSalesRepModal] = useState(false)

    const toggle = () => setDropdownOpen(prevState => !prevState);
    const handleCloseModal = (action) => {
        setDeleteModal(false);
        if (action === "delete") {
            setShouldGetData(true)
        }
    };

    const addActivityHandler = () => {
        if (item ?.owner ?.id) {
            history.push(`${adminPrefix}/leads/add-activity/${item.id}/Lead/${item ?.owner ?.id}`)
        } else {
            toast.error("please assign sales rep first")
        }
    }

    return (
        <>
            <tr key={item.id}>
                <th className="font-size-14">
                    <label className="m-0 d-flex" style={{gap: '8px'}}>
                        <input 
                            type='checkbox' 
                            onChange={e => {
                                if(e.target.checked){
                                    setIdsSelected([...idsSelected, item.id])
                                } else {
                                    setIdsSelected([...idsSelected.filter(res=> res != item.id)])
                                    setSelectAll(false)
                                }
                            }} 
                            checked={!!idsSelected.filter(res=> res == item?.id)?.length}
                        />
                        {item.id}
                    </label>
                </th>
                <th className="font-size-14">{item.name}</th>
                <th className="font-size-14">{item.phone}</th>
                <th className="font-size-14">{item.open_deals}</th>
                <th className="font-size-14">{item ?.owner ?.name}</th>
                <th className="font-size-14">{item.last_visited}</th>
                <th className="font-size-14">{item.nom_searches}</th>
                <th className="font-size-14">
                    <Badge className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(item.status) }}>{item.status}
                    </Badge>
                </th>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth mb-4 py-0" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => { history.push(`${adminPrefix}/leads/view-lead/${item.id}`) }}>View</DropdownItem>
                            {isExist("lead.activity") ?
                                <DropdownItem onClick={addActivityHandler}>Add Activity</DropdownItem>
                                : null}
                            {isExist("lead.feedback") ? <DropdownItem onClick={() => {
                                if (item ?.owner ?.id) {
                                    setFeedbackModal(!feedbackModal)
                                } else {
                                    toast.error("Please assign Sales Rep ")
                                }
                            }}>Add Feedback</DropdownItem> : null}
                            {isExist("lead.assign") ? AuthData.system === "Manual"
                                ?
                                <DropdownItem onClick={() => setSalesRepModal(c => !c)}>
                                    {!!item?.owner?.id ? "Re-assign Sales Rep" : "Assign Sales Rep"}
                                </DropdownItem>
                                : null : null
                            }
                            {isExist("lead.deal") ? <DropdownItem onClick={() => {
                                if (item ?.owner ?.id) {
                                    history.push(`${adminPrefix}/deals/add-deal/${item.id}/${item ?.owner ?.id}`)
                                } else {
                                    toast.error("Please assign Sales Rep ")
                                }
                            }}>Add Deal</DropdownItem> : null}
                            {isExist("lead.appointment") ? <DropdownItem onClick={() => {
                                if (item ?.owner ?.id) {
                                    history.push(`${adminPrefix}/appoinments/book-appoinment/add/${item.id}/${item ?.owner ?.id}`)
                                } else {
                                    toast.error("Please assign Sales Rep ")
                                }
                            }}>Book Appointment</DropdownItem> : null}
                            {isExist("lead.resale") ?
                                <DropdownItem onClick={() => {
                                    if (item ?.owner ?.id) {
                                        history.push(`${adminPrefix}/resale/create-resale/${item.client_id}`)
                                    } else {
                                        toast.error("Please assign Sales Rep ")

                                    }
                                }}>Add Resale</DropdownItem>
                                : null}
                            {isExist("lead.edit") ?
                                <>
                                    <hr className="m-0 p-0" />
                                    <DropdownItem onClick={() => setModalStatus(!modalStatus)} style={{ color: "#212529" }}>Change Status</DropdownItem>

                                </>
                                : null
                            }
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={"Appoinment"}
                deletedItem={item}
                modelService={leadService}
                onCloseModal={(action) => handleCloseModal(action)}
            />
            <StatusModal
                modal={modalStatus}
                toggle={() => setModalStatus(!modalStatus)}
                status={item.status}
                id={item.id}
                setShouldGetData={setShouldGetData}
            />
            {feedbackModal ? <FeedbackModal
                modal={feedbackModal}
                id={item.id}
                toggle={() => setFeedbackModal(!feedbackModal)}
                type="list"
                setShouldUpdateDate={() => { }}
            />
                : null}
            {salesRepModal ? <AssignSalesRepModal
                modal={salesRepModal}
                toggle={() => setSalesRepModal(c => !c)}
                salesRep={{ label: item ?.owner.name, value: item ?.owner ?.id}}
                lead_id={item.id}
                setShouldGetData={setShouldGetData}
            /> : null}
        </>

    );
}


const getBackGround = (status) => {
    return status === "Wrong number" ? "#f1874c"
    : status === "Busy" ? "#f1b44c"
        : status === "Not interested" ? "#50a5f1"
            : status === "Not yet" ? "#74788d"
                : status === "Interested to buy" ? "#931b7f"
                    : status === "Unreachable" ? "#556ee6"
                        : status === "Interested to sell" ? "#54188d"
                            : status === "UIP" ? "#6498ac" 
                            :status==="Deal" ? "#34e38f" :"#95788d"
}
export default CardItem;